export type Client = { id: string; name: string; active: number };

export function clientHeaders(): Record<string, string> {
  const id = sessionStorage.getItem("loop_client");
  return id ? { "X-Loop-Client": id } : {};
}

export async function accessRequest(
  path: string,
  method = "GET",
  body?: unknown,
) {
  const response = await fetch(
    (import.meta.env.VITE_API_BASE_URL || "") + path,
    {
      method,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("auth_token") || ""}`,
        "Content-Type": "application/json",
        ...clientHeaders(),
      },
      body: body === undefined ? undefined : JSON.stringify(body),
    },
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401)
      window.dispatchEvent(new Event("auth:unauthorized"));
    throw new Error(
      typeof data.detail === "string"
        ? data.detail
        : data.message || "Unable to save. Check the fields and try again.",
    );
  }
  return data;
}
